import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import StepHeader from '../../../../components/Layout/StepHeader';
import { floorInsulationOptions } from '../../../../../data/enumerations';
import Slider from 'rc-slider/lib/Slider';
import FormControl from '../../../../components/Form/FormControl';
import CheckCard from '../../../../components/Form/CheckCard';
import { Form } from 'formik';

const StepFloorInsulationThickness = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();
    const selectedInsulationType = floorInsulationOptions.find((option) => option.value === values.floorInsulation);

    useEffect(() => {
        if (values.floorInsulationThickness) {
            completeStep && completeStep(true);
        }
    }, [values]);

    return (
        <Form>
            <div className="otz-main otz-main--counter">
                <StepHeader title="Zateplení podlahy" />
                <div className="row">
                    <div className="col--12 col--lg-3 otz-slider__left">
                        <div className={'otz-slider__card'}>
                            {selectedInsulationType && (
                                <div className={'wiz-card-item'}>
                                    <CheckCard
                                        name={'floorInsulation'}
                                        onChange={handleChange}
                                        checked={true}
                                        value={selectedInsulationType.value}
                                        img={selectedInsulationType.img}
                                        bigImg={true}
                                        title={selectedInsulationType.title}
                                        description={selectedInsulationType.description}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col--12 col--lg-9">
                        <div className="otz-slider">
                            <div className="otz-slider__content">
                                <div className="otz-slider__title">Odhadovaná tloušťka zateplení</div>
                                <div className="otz-slider__input">
                                    <FormControl
                                        name="floorInsulationThickness"
                                        id="floorInsulationThickness"
                                        tag="input"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.floorInsulationThickness}
                                        //error={errors.wallInsulationThickness}
                                        readonly={true}
                                    />
                                    <div className="wiz-form-text">mm</div>
                                </div>
                                <div className="otz-slider__slider">
                                    <Slider
                                        className="react-slider"
                                        min={0}
                                        max={200}
                                        step={50}
                                        value={Number(values.floorInsulationThickness)}
                                        onChange={(curProp) =>
                                            handleChange('floorInsulationThickness')(curProp.toString())
                                        }
                                    />
                                </div>
                                <div className="otz-slider-units">
                                    <div className="otz-slider-units__item">0 mm</div>
                                    <div className="otz-slider-units__item">50 mm</div>
                                    <div className="otz-slider-units__item">100 mm</div>
                                    <div className="otz-slider-units__item">150 mm</div>
                                    <div className="otz-slider-units__item">200 mm</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepFloorInsulationThickness;
